import {createStore, applyMiddleware} from 'redux';
import {routerMiddleware} from 'react-router-redux';

import createSagaMiddleware from 'redux-saga';

import {default as rootReducer, appSaga} from 'ducks';
import history from './history';
import Raven from './sentry';

const crashReporter = store => next => action => {
  try {
    return next(action);
  } catch (err) {
    Raven.captureException(err, {
      extra: {
        action,
        state: store.getState()
      }
    });
    throw err;
  }
};

const captureSagaException = exception => {
  Raven.captureException(exception);
  console.error(exception);
};

const sagaMiddleware = createSagaMiddleware({onError: captureSagaException});
const middleware = [sagaMiddleware, crashReporter, routerMiddleware(history)];
const enchancers: Array<any> = [];
const currentWindow: any = window;

if (
  process.env.NODE_ENV === 'development' &&
  currentWindow.__REDUX_DEVTOOLS_EXTENSION__
) {
  enchancers.push(currentWindow.__REDUX_DEVTOOLS_EXTENSION__());
}

const store = createStore(
  rootReducer,
  ...enchancers,
  applyMiddleware(...middleware)
);

sagaMiddleware.run(appSaga);

export default store;
